import React from 'react'
import {  getDefaultKeyBinding, KeyBindingUtil} from 'draft-js';

// Redraft
export const renderers = { 
    inline: {
    BOLD: (children, { key }) => <strong key={key}>{children}</strong>,
    ITALIC: (children, { key }) => <em key={key}>{children}</em>,
    UNDERLINE: (children, { key }) => <u key={key}>{children}</u>,
    CODE: (children, { key }) => <span key={key} className='code'>{children}</span>,
  },
    blocks: {
    unstyled: (children, { key } ) => children.map(child => <span key={key}>{child}</span>),
    blockquote: (children) => <blockquote >{children}</blockquote>,
    'header-one': (children) => children.map(child => <h1>{child}</h1>),
    'header-two': (children) => children.map(child => <h2>{child}</h2>),
    // You can also access the original keys of the blocks
    'code-block': (children, { keys }) => <pre className='codeBlock' key={keys[0]} >{children}</pre>,
    // or depth for nested lists
    'unordered-list-item': (children, { depth, keys }) => <ul key={keys[keys.length - 1]} className={`ul-level-${depth}`}>{children.map((child, key) => <li key={key} >{child}</li>)}</ul>,
    'ordered-list-item': (children, { depth, keys }) => <ol key={keys.join('|')} className={`ol-level-${depth}`}>{children.map((child, index)=> <li key={keys[index]}>{child}</li>)}</ol>,
    // If your blocks use meta data it can also be accessed like keys
    //atomic: (children, { keys, data }) => children.map((child, i) => <Atomic key={keys[i] {...data[i]}/>),
  },
 
  entities: {
    // key is the entity key value from raw
    LINK: (children, data, { key }) => <a key={key} className='linkcontrib' href={data.url} target="_blank">{children}</a>,
  },
}

//keybinding function for control-s = save
export const controlSave = (e) => {
  if (e.keyCode === 83 && KeyBindingUtil.hasCommandModifier(e)) {
    return 'myeditor-save';
  }
  return getDefaultKeyBinding(e);
}

export const BLOCK_TYPES = [
        {label: 'H1', style: 'header-one'},
        {label: 'H2', style: 'header-two'},
        {label: 'H3', style: 'header-three'},
        {label: 'H4', style: 'header-four'},
        {label: 'H5', style: 'header-five'},
        {label: 'H6', style: 'header-six'},
        {label: 'Blockquote', style: 'blockquote'},
        {label: 'UL', style: 'unordered-list-item'},
        {label: 'OL', style: 'ordered-list-item'},
        {label: 'Code Block', style: 'code-block'},
      ];

export const INLINE_STYLES = [
        {label: 'Bold', style: 'BOLD'},
        {label: 'Italic', style: 'ITALIC'},
        {label: 'Underline', style: 'UNDERLINE'},
        {label: 'Monospace', style: 'CODE'},
      ];

//colorS

export const COLORS = [
        {label: 'Red', style: 'red'},
        {label: 'Orange', style: 'orange'},
        {label: 'Yellow', style: 'yellow'},
        {label: 'Green', style: 'green'},
        {label: 'Blue', style: 'blue'},
        {label: 'Rose', style: 'rose'},
        {label: 'White', style: 'white'},
      ];
export const RESCOLORS = [
        {label: 'Red', style: 'red'},
        {label: 'Orange', style: 'orange'},
        {label: 'Yellow', style: 'yellow'},
        {label: 'Green', style: 'green'},
        {label: 'Blue', style: 'blue'},
        {label: 'Rose', style: 'rose'},
        {label: 'Black', style: 'black'},
      ];
export const colorStyleMap = {
        red: {
          color: '#E74C3C',
        },
        orange: {
          color: 'rgba(255, 127, 0, 1.0)',
        },
        yellow: {
          color: 'gold',
        },
        green: {
          color: 'lightgreen',
        },
        blue: {
          color: '#5e93c5',
        },
        rose: {
          color: 'palevioletred',
        },
        white: {
          color: 'lightgrey',
        },
      };

export const ResColorStyleMap = {
        red: {
          color: '#E74C3C',
        },
        orange: {
          color: 'rgba(255, 127, 0, 1.0)',
        },
        yellow: {
          color: 'gold',
        },
        green: {
          color: 'lightgreen',
        },
        blue: {
          color: '#5e93c5',
        },
        rose: {
          color: 'palevioletred',
        },
        black: {
          color: 'black',
        },
      };
const butStyle = {
          color: '#ECF0F1',
          cursor: 'pointer',
        }


// WEBPACK FOOTER //
// ./src/draftUtilities.js